import { useBrandProfileAnalysis, Props } from 'hooks/queries/brandProfiles/useBrandProfileAnalysis'
import { AIJobStatus } from 'types'
import { PollBrandProfileAnalysisOptions } from 'components/FirstTimeExperienceModal/steps/BrandProfile/Types'

export const usePollBrandProfileAnalysis = (props: Props, options?: PollBrandProfileAnalysisOptions) => {
  return useBrandProfileAnalysis(props, {
    refetchInterval: (data) => {
      const status = data?.brand_profile_analysis?.status
      if (!status) {
        return false
      }

      if (status === AIJobStatus.Pending || status === AIJobStatus.Started) {
        return 500
      }

      return false
    },
    ...options,
  })
}
